<template>
  <b-table v-if="queries.length > 0" :items="queries" :fields="fields" class="table table-striped" stacked="sm">
		<template slot="actions" slot-scope="row">
			<b-button-group class="">
				<b-button variant="primary" @click="edit(row.item.id)" v-b-tooltip.hover title="Edit">
					<font-awesome-icon icon="edit" />
				</b-button>
				<button type="submit" class="btn btn-danger btn-xs" v-b-tooltip.hover title="Delete"
					@click="del(row.item.id, row.index)"><font-awesome-icon icon="trash-alt" />
				</button>
			</b-button-group>
		</template>
		<template slot="updated" slot-scope="row">
				{{row.item.updated_at}}
		</template>
	</b-table>
</template>

<script>
  export default {
    components: {

    },
    props: {
      queries: {
        type: Array,
        default: () => []
      },
      fields: {
        type: Array,
        default: () => ['name', 'updated', 'actions']
      }
    },
    data() {
      return {
        
      }
    },
    computed: {

    },
    methods: {
      edit(id) {
				this.$router.push({name: 'query.edit', params: {query_id: id}});
			},
			del(id, index) {
				this.$swal({
					title: 'Be careful',
					text: "All the visualizations related to this query will be deleted",
					type: 'warning',
					width: '350px',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					confirmButtonText: 'Confirm'
				}).then((result) => {
					if (result.value) {
						let payload = {
							id: id,
							index: index
						};
						this.$store.dispatch('queries/delete', payload);
					}
				})
			},
    },
  }
</script>
